import { createContext } from 'react'
import { SupplyTypes } from '../types'

export const SupplyTypesContext = createContext<SupplyTypes>(null)
